import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { OrganizationType } from "../../utils/types";
import { Pagination } from "../../components/pagination";
import { Toggle } from "../../components/toggle";
import ExportDataModal from "./components/ExportDataModal";
import ImportDataModal from "./components/ImportDataModal";
import { api, getOrganization } from "../../services/axios";

export const Organizations = () => {
  const [organizations, setOrganizations] = useState<OrganizationType[]>([]);
  const history = useHistory();
  const [searchField, setSearchField] = useState("full_name");
  const [searchText, setSearchText] = useState("");

  const [sort, setSort] = useState("asc");

  const [limit, setLimit] = useState<number>(25);
  const [total, setTotal] = useState<number>(0);

  const [pageNumber, setPageNumber] = useState<number>(0);

  const [modalVisible, setModalVisible] = useState(false);
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [showOnlyNationals, setShowOnlyNationals] = useState(false);

  const disabledSearch = searchText.length === 0;

  const notificationMethods = [
    { id: "asc", title: "Ascending" },
    { id: "desc", title: "Descending" },
  ];

  useEffect(() => {
    if (showOnlyNationals) {
      let filtered = organizations.filter((x) => x.national);
      setOrganizations(filtered);
    } else {
      getOrganizationsFilter();
    }
  }, [showOnlyNationals]);

  const getOrganizationsFilter = async () => {
    try {
      let res;
      if (disabledSearch) {
        res = await api.get(
          `organizations/search?field=${searchField}&sort=${sort}&size=${limit}`
        );
      } else {
        res = await api.get(
          `organizations/search?field=${searchField}&sort=${sort}&size=${limit}&value=${searchText}`
        );
      }

      const nextOrganizations = await fetchOrgParents(res?.data?.Items);
      //@ts-ignore
      setOrganizations(nextOrganizations);
      setTotal(res?.data?.Total);
    } catch (e) {
      console.log(e);
    }
  };

  const clearOrganizations = async () => {
    try {
      let res = await api.get(`organizations/search?size=${limit}`);

      const nextOrganizations = await fetchOrgParents(res?.data?.Items);

      //@ts-ignore
      setOrganizations(nextOrganizations);
      setTotal(res?.data?.Total);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getOrganizationsFilter();
  }, [limit]);

  const paginationChange = async (type: string) => {
    console.log(type);
    const nextPageNumber = type === "next" ? pageNumber + 1 : pageNumber - 1;
    const start = limit * nextPageNumber;
    setPageNumber(nextPageNumber);

    let res;
    if (type === "next") {
      if (disabledSearch) {
        res = await api.get(
          `organizations/search?field=${searchField}&sort=${sort}&size=${limit}&start=${start}`
        );
      } else {
        res = await api.get(
          `organizations/search?field=${searchField}&sort=${sort}&size=${limit}&value=${searchText}&start=${start}`
        );
      }
    } else {
      if (disabledSearch) {
        res = await api.get(
          `organizations/search?field=${searchField}&sort=${sort}&size=${limit}&start=${start}`
        );
      } else {
        res = await api.get(
          `organizations/search?field=${searchField}&sort=${sort}&size=${limit}&value=${searchText}&start=${start}`
        );
      }
    }

    const nextOrganizations = await fetchOrgParents(res?.data?.Items);

    //@ts-ignore
    setOrganizations(nextOrganizations);
    setTotal(res?.data?.Total);
    console.log(start);
  };

  const fetchOrgParents = async (orgs: OrganizationType[]) => {
    try {
      const next = await Promise.all(
        orgs.map(async (org) => {
          if (org.parents.length === 0) {
            return org;
          }
          const p = await Promise.all(
            org.parents?.map(async (parent) => {
              let org = (await getOrganization(parent)) as OrganizationType;
              if (org) {
                return org;
              }
              return "";
            })
          );
          const filtered = p.filter(function (x) {
            return x !== "";
          });
          return {
            ...org,
            parents: filtered,
          };
        })
      );
      return next;
    } catch (e) {
      console.log(e);
    }
  };

  const changeLimit = (event: any) => {
    const value = parseInt(event.target.value);

    if (value > 0) {
      setLimit(value);
      setPageNumber(1);
    }
  };

  function goToOrganization(id: string) {
    history.push({
      pathname: `/organization/${id}`,
    });
  }

  const organizationsMaps = organizations.map((organization, index) => {
    return (
      <tr key={index} className="p-2 m-2 group">
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
          {organization.account_name ? organization.account_name : ""}
        </td>
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
          {organization.salesforce_id ? organization.salesforce_id : ""}
        </td>
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
          {organization.full_name ? organization.full_name : ""}
        </td>
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
          {organization.national === "True" || organization.national === "TRUE"
            ? "yes"
            : "no"}
        </td>
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
          {organization.parents &&
            organization.parents.length > 0 &&
            //@ts-ignore
            organization.parents
              .map((parent: any) => (parent.full_name ? parent.full_name : ""))
              .join(", ")}
        </td>
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
          {organization.category ? organization.category : ""}
        </td>
        <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
          {organization.menu_name ? organization.menu_name : ""}
        </td>
        <td className="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
          <button
            onClick={() => goToOrganization(organization.salesforce_id)}
            className="text-indigo-600 hover:text-indigo-900"
          >
            View
            <span className="sr-only">, {organization.salesforce_id}</span>
          </button>
        </td>
      </tr>
    );
  });

  return (
    <div className="m-8">
      <div className="flex justify-between border-b">
        <div className="p-2">Organizations</div>
        <div></div>
        <div className="flex justify-between">
          <Link to="/create-organization">Add New</Link>
        </div>
      </div>
      <div className="mt-12 flex w-2/3 items-end">
        <div className="w-4/5">
          <label
            htmlFor="filter"
            className="block text-sm font-medium text-gray-700"
          >
            Filter
          </label>
          <div className="mt-1 relative rounded-md shadow-sm w-full">
            <div className="absolute inset-y-0 left-0 flex">
              <label htmlFor="country" className="sr-only">
                Search
              </label>
              <select
                id="country"
                name="country"
                autoComplete="country"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
                className="border-r border-gray-300 w-40 focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-3 pr-7 bg-gray-100 text-gray-500 sm:text-sm rounded-md"
              >
                <option value="none" disabled hidden>
                  Select an Option
                </option>
                <option value="account_name">Account Name</option>
                <option value="full_name">Name</option>
                <option value="category">Category</option>
                <option value="menu_name">Campus Category</option>
                <option value="salesforce_id">Salesforce Id</option>
              </select>
            </div>
            <input
              type="text"
              name="search-text"
              id="search-text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-48 sm:text-sm border-gray-300 rounded-md"
              placeholder="Search organizations by text (case sensitive)"
            />
          </div>
        </div>
        <button
          type="button"
          //@ts-ignore
          onClick={getOrganizationsFilter}
          disabled={disabledSearch}
          className={`${
            disabledSearch
              ? "text-gray-400 bg-gray-100 hover:bg-gray-100 cursor-not-allowed"
              : "text-white bg-indigo-600 hover:bg-indigo-700 "
          } ml-4 inline-flex items-center px-4 py-1.5 border border-transparent text-xs 
          font-medium rounded shadow-sm 
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
        >
          Search
        </button>
        <button
          type="button"
          onClick={() => {
            setSearchText("");
            setSearchField("full_name");

            clearOrganizations();
          }}
          className="ml-4 inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Reset
        </button>
      </div>
      <div className="flex justify-between">
        <fieldset className="mt-4">
          <legend className="sr-only">Notification method</legend>
          <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
            {notificationMethods.map((notificationMethod) => (
              <div key={notificationMethod.id} className="flex items-center">
                <input
                  id={notificationMethod.id}
                  name="notification-method"
                  type="radio"
                  onClick={() => setSort(notificationMethod.id)}
                  defaultChecked={notificationMethod.id === sort}
                  className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                />
                <label
                  htmlFor={notificationMethod.id}
                  className="ml-3 block text-sm font-medium text-gray-700"
                >
                  {notificationMethod.title}
                </label>
              </div>
            ))}
          </div>
        </fieldset>
        <div className="flex items-center mt-4">
          <Toggle
            onoff={showOnlyNationals}
            onChange={() => setShowOnlyNationals(!showOnlyNationals)}
          />
          <p className="ml-2">Show Only National Greek</p>
        </div>

        <div>
          <button
            type="button"
            onClick={() => {
              setImportModalVisible(true);
            }}
            className={`border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-indigo-500 ml-4 inline-flex items-center px-2.5 py-1.5 border shadow-sm text-xs font-medium rounded  focus:outline-none focus:ring-2 focus:ring-offset-2 `}
          >
            Import Data
          </button>
          <button
            type="button"
            onClick={() => {
              setModalVisible(true);
            }}
            className={`border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-indigo-500 ml-4 inline-flex items-center px-2.5 py-1.5 border shadow-sm text-xs font-medium rounded  focus:outline-none focus:ring-2 focus:ring-offset-2 `}
          >
            Export Data
          </button>
        </div>
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div className="group inline-flex">Account Name</div>
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div className="group inline-flex">Salesforce ID</div>
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div className="group inline-flex">Name</div>
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div className="group inline-flex">National Greek</div>
                    </th>
                    <th className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6 text-left">
                      Parents
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div className="group inline-flex">Category</div>
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div className="group inline-flex">Campus Category</div>
                    </th>
                    <th className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6 text-left"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {organizationsMaps}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {organizations && organizations.length > 0 && (
        <Pagination
          limit={limit}
          changeLimit={changeLimit}
          paginationChange={paginationChange}
          pageSize={[1, 2, 5, 10, 20, 50]}
          pageNumber={pageNumber}
          hasMore={pageNumber * limit < total}
        />
      )}

      <ExportDataModal
        open={modalVisible}
        setOpen={setModalVisible}
        query={[searchField, searchText]}
      />

      <ImportDataModal
        open={importModalVisible}
        setOpen={setImportModalVisible}
      />
    </div>
  );
};
